<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-group element-bodymatter element-type-part element-with-heading" id="part-1">
<div class="heading heading-with-title heading-without-image" id="part-1-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Part One</h1>
</div>
<h2 class="subtitle">A Harder Job Than It Looks</h2>
</div>
</div>
</div>
<div class="text" id="part-1-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><i>“It’s a thankless job. I wouldn’t want to do it. Could they pay me to do what they did? No way.”</i></p>
<p class="alignment-block-content alignment-block-content-center"><i>—</i>Jerry Glanville, Former NFL Head Coach.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?df88281c